import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestProductivitySalaryListService = (
  params: Types.ApprovalRequestProductivitySalaryListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestProductivitySalaryListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestProductivitySalaryCreateService = (
  params: Types.ApprovalRequestProductivitySalaryCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestProductivitySalaryUpdateService = (
  params: Types.ApprovalRequestProductivitySalaryUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestProductivitySalaryDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequestProductivitySalary>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestProductivitySalaryApproveService = (
  params: Types.ApprovalRequestProductivitySalaryApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestProductivitySalary>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestProductivitySalaryCheckAllowRequestService =
  (params: { year: number; month: number }) =>
    RestAPIClient.call<{
      isAllowSendRequest: boolean;
    }>({
      method: HTTPRequestMethods.GET,
      url: Paths.AllowRequest,
      config: {
        requireAuthentication: true,
        params,
      },
    });
